var path = 'views/templates/fillMeter.html';
var html = "<div class=\"fill-meter-container\"> <div class=\"meter-count\">{{meterCount}}</div> <div class=\"fill-meter\"> <span class=\"fill-meter-bar\"></span> </div> </div> ";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;